import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext.tsx';
import { FacilityProvider } from './contexts/FacilityContext.tsx';
import { ThemeProvider } from './contexts/ThemeContext.tsx';
import { PageFocusProvider } from './contexts/PageFocusContext.tsx';
import { BillingConfigProvider } from './contexts/BillingConfigContext.tsx';
import ProtectedRoute from './components/ProtectedRoute.tsx';
import LockGate from './components/LockGate.tsx';
import AppLayout from './components/Layout/AppLayout.tsx';
import LoginPage from './pages/Login.tsx';
import DashboardPage from './pages/Dashboard.tsx';
import InventoryPage from './pages/Inventory.tsx';
import ItemDetail from './pages/ItemDetail.tsx';
import VendorsPage from './pages/Vendors.tsx';
import OrdersPage from './pages/Orders.tsx';
import TasksPage from './pages/Tasks.tsx';
import SchedulePage from './pages/Schedule.tsx';
import FinancialsPage from './pages/Financials.tsx';
import SettingsPage from './pages/Settings.tsx';
import HelpPage from './pages/Help.tsx';
import UsersPage from './pages/Users.tsx';
import ResetPasswordPage from './pages/ResetPasswordPage.tsx';
import ProjectsPage from './pages/Projects.tsx';
import ReportsPage from './pages/Reports.tsx';
import BOMView from './pages/BOMView.tsx';
import LearningHubPage from './pages/LearningHub.tsx';
import BillingPage from './pages/Billing.tsx';

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <FacilityProvider>
        <PageFocusProvider>
        <BillingConfigProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <LockGate>
                  <AppLayout />
                </LockGate>
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="inventory" element={<InventoryPage />} />
            <Route path="inventory/item/:id" element={<ItemDetail />} />
            <Route path="inventory/:id/bom" element={<BOMView />} />
            <Route path="vendors" element={<VendorsPage />} />
            <Route path="orders" element={<OrdersPage />} />
            <Route path="tasks" element={<TasksPage />} />
            <Route path="schedule" element={<SchedulePage />} />
            <Route path="financials" element={<FinancialsPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="help" element={<HelpPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route
              path="projects"
              element={
                <ProtectedRoute requiredRoles={['manager', 'org_admin', 'admin']}>
                  <ProjectsPage />
                </ProtectedRoute>
              }
            />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="learning-hub" element={<LearningHubPage />} />
            <Route
              path="billing"
              element={
                <ProtectedRoute requiredRoles={['manager', 'org_admin', 'admin']}>
                  <BillingPage />
                </ProtectedRoute>
              }
            />
          </Route>

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        </BillingConfigProvider>
        </PageFocusProvider>
        </FacilityProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
